export const HELP_LEADERBOARD_NAME = `The name of the leaderboard config, and how the leaderboard will be identified.

This name can contain numbers, letters, and dashes.

Please note that once the leaderboard is created, the name cannot be changed.`;

export const HELP_LEADERBOARD_ORDER = `The ranking order of scores on the leaderboard.  
    
Descending - Scores are ranked highest to lowest.
    
Ascending - Scores are ranked lowest to highest.`;

export const HELP_LEADERBOARD_TIMEFRAMES = 'The rotation schedule of the leaderboard.';

export const HELP_TIMEFRAME_RETENTION = `The number of leaderboards to keep. 

Example, a value of 3 for a WEEKLY leaderboard will retain up to 3 leaderboards, or 3 WEEKS worth of leaderboards instead.

In contrast a value of 5 for a DAILY leaderboard will retain 5 leaderboards, or 5 DAYS worth of leaderboards.`;

export const HELP_TIMEFRAME_ARCHIVE = `Store the leaderboard after the retention period is over. 
The leaderboard files are available for retrieval in the future.`;

export const HELP_TIMEFRAME_ROTATION_TRIGGER = `This is used to determine when to rollover the yearly/monthly/weekly/daily timeframes. 

When "yearly" is selected, the month/day/hour/minutes are used for the next rollover day. 

When "monthly" is selected, the the day of the month/hour/minute is used.  In the case that you use a day of the month that is > 28, then any months that have fewer days will use the final day of that month instead.

When "weekly" is selected, the the day of the week/hour/minute is used for the rollover. 

When "daily" is selected,  only the hour and minute is used for the rollover.`;

export const HELP_TIMEFRAME_START_DATES = `The start times for each leaderboard.  Scores will be posted to the leaderboard that has the closest date, but is greater than or equal to the leaderboards start date. 

For example, if you specify the following start_dates: ["May 11, 2023 12:00 PM", " May 13, 2023 12:00 PM", "May 15, 2023 12:00 PM"], then: 

A post date of "May 12, 2023 10:55 AM" will be added to the "May 11, 2023 12:00 PM" leaderboard. 

A post date of "May 13, 2023 12:13: PM" will be added to the "May 13, 2023 12:00 PM" leaderboard. 

A post date of "May 15, 2023 3:49 AM" will be added to the "May 15, 2023 12:00 PM" leaderboard. 

In the case where you try to load scores with a post date that is under the earliest leaderboard, then the scores will be dropped.`;

export const HELP_SCORECONFIG = 'Handle the scores.';

export const HELP_SCORECONFIG_TYPE = `The score process. 

Insert Only - The user's score will always create a new record in the leaderboard. 
This is useful for a "high score" leaderboard.

Note that you need to provide a unique ID for each entry you want to add to the leaderboard. If a previous entry has the same ID, the score won't be recorded. If you choose this option, you'll also need to define a "capacity" value.

Increment - The user's score will accumulate if it already exists or create a new record if it doesn't.

High Score - Only scores that are higher than the previously registered score will be updated.

Low Score - Only scores that are lower than the previously registered lowest score will be updated.`;

export const HELP_SCORECONFIG_CAPACITY = `This option determines how many scores to keep in this leaderboard.

Note: Capacity only applies to "Insert Only" types.`;

export const HELP_SCORECONFIG_HAS_DATA = `If checked, then an additional "data" field will be sent with each score to the database. 

This data field will be overwritten on subsequent updates to the score, and when the leaderboard is retrieved, the data will also be sent`;
export const HELP_LEADERBOARD_DATA = `A text field that can carry any additional data about the leaderboard that you want, in any format you want.

Example: To add additional context to the leaderboard like a friendly display name`;

export const LEADERBOARD_CONFIGS_HEADING = 'Manage Leaderboard Configs';
export const LEADERBOARD_CONFIGS_CREATE_BUTTON_LABEL = 'Create New Leaderboard Config';
export const LEADERBOARD_CONFIGS_DATA_TABLE_TITLE = 'Current Leaderboard Configs';
export const LEADERBOARD_CONFIGS_NO_LEADERBOARDS =
    'You currently do not have any leaderboard configs.';
